<template>
<div id="mystore_page">
    <div id="mystore_wrap">
        <div class="mystore-content">
            <div class="store-wrap">
                <ul v-if="store_list.length !== 0">
                    <li class="mystore-list" :key="index" v-for="(item, index) in store_list" @click="goKioskMobile(item.store_id, item.user_id, item.store_name)" >
                        <div class="mystore-card">
                            <div class="card-top">
                                <div>
                                    <h4>{{item.store_name}}</h4><img src="../../assets/images/icon_link.png" alt="바로가기">
                                </div>
                                <div v-if="item.seat_use_id || item.groom_use_id"><span>이용중</span></div>
                            </div>
                            <div class="card-content">
                                <div class="mystore-img" :style="{background: 'url('+host_url+'/'+item.photograph_path+') no-repeat center center/cover' }"></div>
                                <div class="mystore-info">
                                    <div class="myproduct">
                                        <div class="seat-product product-type">
                                            <div class="product-title">좌석상품</div>
                                            <ul>
                                                <li v-if="item.free_count != 0"><span>개인석 <strong class="number">{{item.free_count}}</strong>개</span></li>
                                                <li v-if="item.fixed_count != 0"><span>고정석 <strong class="number">{{item.fixed_count}}</strong>개</span></li>
                                                <li v-if="item.free_count == 0 && item.fixed_count == 0"><span>-</span></li>
                                            </ul>
                                        </div>
                                        <div class="locker-product product-type">
                                            <div class="product-title">사물함</div>
                                            <ul>
                                                <li v-if="item.locker_name"><span>{{item.locker_name}}번</span></li>
                                                <li v-if="item.locker_name">
                                                    <span>
                                                        <span v-if="item.use_end_datetime" class="end_day">만료일<br></span>
                                                        <span><strong class="number">{{item.use_end_datetime}}</strong></span>
                                                    </span>
                                                </li>
                                                <li v-if="!item.locker_name"><span>-</span></li>
                                            </ul>
                                        </div>
                                        <div class="groom-product product-type">
                                            <div class="product-title">그룹룸</div>
                                            <ul>
                                                <li v-if="item.groom_purchase_count != 0"><span>상품 <strong class="number">{{item.groom_purchase_count}}</strong>개</span></li>
                                                <li v-if="item.groom_reservation_count != 0"><span>예약 <strong class="number">{{item.groom_reservation_count}}</strong>개</span></li>
                                                <li v-if="item.groom_purchase_count == 0 && item.groom_reservation_count == 0"><span>-</span></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="mymileage">
                                        <img src="../../assets/images/icon_point.png" alt="마일리지">
                                        <span>마일리지 {{item.total_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>

                </ul>
                <ul v-else style="position: absolute; top: 50%; margin-top: -8px; left: 50%; margin-left: -75px; color: #007aff;">
                    등록된 매장이 없습니다
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import * as config from '../../js/config';
import common from '../../js/common';

export default {
    name: 'mystore_page',

    data() {
        return {
            store_list: [],
            host_url: ''
        }
    },
    mounted() {
        this.$nextTick(function () {
            this.host_url = config.HOST;
            var user_info = this.$store.getters['getUser_info'];
            var data = {
                user_hp: user_info.value.user_hp,
                m_user_id: user_info.value.m_user_id
            }
            var type = config.REQ_MY_STORE_DETAIL_LIST;
            common.getData(type, data,
                (response) => {
                    this.store_list = response;
                    this.store_list.sort(function (a, b) {
                        return (a.seat_use_id === null) - (b.seat_use_id === null) || (a.groom_use_id === null) - (b.groom_use_id === null);
                    })
                    console.log(this.store_list);
                    for (let i = 0; i < this.store_list.length; i++) {
                        if (this.store_list[i].free_count == null) {
                            this.store_list[i].free_count = 0;
                        }
                        if (this.store_list[i].fixed_count == null) {
                            this.store_list[i].fixed_count = 0;
                        }
                        if (this.store_list[i].groom_reservation_count == null) {
                            this.store_list[i].groom_reservation_count = 0;
                        }
                        if (this.store_list[i].groom_purchase_count == null) {
                            this.store_list[i].groom_purchase_count = 0;
                        }
                        if (this.store_list[i].total_amount == null) {
                            this.store_list[i].total_amount = 0;
                        }
                        if (this.store_list[i].photograph_path == null) {
                            this.store_list[i].photograph_path = '/images/MOBILE/defalut.jpg'
                        }
                    }
                })
        });
    },
    methods: {
        goKioskMobile(store_id, user_id, store_name){
            var data = {};
            data.store_id = store_id;
            data.user_id = user_id;
            data.store_name = store_name;
            var params = JSON.stringify(data);
            common.goKioskMobile(params);
        },
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/MystorePage.vue